import { Grid } from '@mui/material';
import { dateUtils, Loader } from 'fso-fincrime-sdk-ui';
import { useState } from 'react';

import ChartSelector from './ChartSelector';
import DateFilter from './filters/DateFilter';
import { IChart } from '../../ts/entities/chart/IChart';

import './ChartContainer.scss';

const ChartContainer = ({
  data,
  chartType,
  loading,
  isDatePickerEnabled,
}: IChart): React.JSX.Element => {
  const [toDate, setToDate] = useState<string | null | undefined>(dateUtils.getLastDate(0));
  const [fromDate, setFromDate] = useState<string | null | undefined>(undefined);

  const chipClickHandle = (bachDay: number): void => {
    setFromDate(dateUtils.getLastDate(bachDay));
    setToDate(dateUtils.getLastDate(0));
  };

  return (
    <Grid item xs={12} className="charts-grid">
      {isDatePickerEnabled && (
        <Grid item xs={12} className="charts-date-picker-container">
          <DateFilter
            toDate={toDate}
            fromDate={fromDate}
            setToDate={setToDate}
            setFromDate={setFromDate}
            chipClickHandle={chipClickHandle}
          />
        </Grid>
      )}
      {loading ? <Loader /> : <ChartSelector data={data} chartType={chartType} />}
    </Grid>
  );
};

export default ChartContainer;
